<footer class="footer">
    <nav class="menu">
        <a routerLink="terms-conditions" class="menu-link">Terms & Conditions</a>
        <a routerLink="privacy" class="menu-link">Privacy Statement</a>
        <a routerLink="accessibility" class="menu-link"> Accessibility</a>
    </nav>
    <p class="copyright">Copyright © {{date | date:'yyyy'}} {{SiteName}}, Inc. All Rights Reserved.</p>
</footer>
